import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'suffix',
    label: 'Suffix',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cellPhoneNumber',
    label: 'Cell Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const titleHolderInformationForm = {
  name: FormNames.TITLE_HOLDER_INFORMATION,
  label: 'Title Holder Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
